import moment from 'moment';
const state= {
    Items:{
        data:[],
        total:0,
        pages: {}
    },
    Groups:null,
    Loadings:{
        item:true,
        group:true,
        popup:false,
        import:false,
        service:true,
    },
    sorItem:{
        name:null,
        description: null,
        sor_code:null,
        sor_group_id:null,
        sor_group:null,
        service_category:null,
        original_unit_price:null,
        unit_price:null,
        unit_price_tmp:null,
        _start_date:null,
        unit_of_measurement:null,
        max_qty:null,
        min_qty:null,
        contract_term_id:null,
        service_category_id:null,
        fault_type:null,
        work_type:null,
        equipment_structure_type:null,
        equipment_group_id:null,
        brand:null,
        model:null,
        is_maintenance:null,
        tolerance_period:null,
        sor_recurring_mode_id:null,
        checklist_template_id:null,
        contract_term:null,
        standard_reference: null,
        remarks: null,
        abbreviation: null,
        location_info: null,
        property_id: null,
        warranty: null,
        tag: null,
        is_allow_time_manual: false,
        number_of_required_signature: '0',
        checklist_mandatory_complete: false,
        is_allow_job_end: false,
        auto_expried: ["Pending","Planned","Due","Started"],
        editing_of_issue: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
        editing_of_checklist: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
        editing_of_job_data: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
        is_allow_editing_of_follow_up_after_job_completion: false,
        last_activity_to_upcoming_activity:0,
        is_allow_user_to_enter_timestamp_for_issue_action_taken: false,
        auto_renew_job: null,
        brand: null,
        default_supplier: null,
        default_supplier_id: null,
        pre_condition_checklist_template_id: null,
        is_pre_condition_checklist_mandatory_complete: false,
        is_allow_uploading_photos_gallery_mobile: false,
        is_allow_auto_fill_checklist_mobile: true,
        geo_fencing_applicable_states: null,
        is_allow_auto_creating_cwo_from_jobs_issues: false,
        is_allow_fm_officer_to_do_expired_jobs: false,
    },
    Services:[],
    Validate: false,
    serviceCategories: []
};

const getters = {
    Items : (state) => state.Items,
    Groups : (state) => state.Groups,
    Loadings : (state) => state.Loadings,
    sorItem : (state) => state.sorItem,
    sorGroup : (state) => state.sorGroup,
    Services : (state) => state.Services,
    Validate : (state) => state.Validate,
    serviceCategories : (state) => state.serviceCategories,
    sorBrands : (state) => state.brands,
};

const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            if(!params.noCommit) {
                commit('setLoadings', {key: "item", val: true});
            }
            global.axios.get(`api/sor`, {params:params})
                .then(response => {
                    if(!params.noCommit) {
                        response.data.data.pages = params
                        commit('setLoadings', {key: "item", val: false});
                        commit('setItems', response.data.data);
                    }
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getItemsSupplier({commit}, params){
        let isCMS = params.isCMS;
        let group_id = params.group_id;
        let page = params.page;
        let limit = params.limit;
        let filter = params.filter;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "item",val: true} );
            global.axios.get(`api/s-contracts/${params.contract_id}/sor`, {params:{
                    isCMS: isCMS,
                    group_id: group_id,
                    page:page,
                    limit:limit,
                    filter:filter,
                }})
                .then(response => {
                    response.data.data.pages = params
                    commit( 'setLoadings', {key: "item",val: false} );
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItem({dispatch,commit,state},params){
        let ids = params;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "item",val: true} );
            global.axios.delete(`api/sor`,{
                data:{
                    ids:ids
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });

    },
    async saveSorItem({dispatch,commit,state},term_id){
        //Check require data

        let dataSor = state.sorItem;
        dataSor.contract_term_id = term_id;
        dataSor.max_qty = parseInt(dataSor.max_qty);
        dataSor.min_qty = parseInt(dataSor.min_qty);
        dataSor.original_unit_price = dataSor.original_unit_price ? parseFloat(dataSor.original_unit_price) : 0;
        dataSor.effective_date = dataSor._start_date ? moment(dataSor._start_date).format("YYYY-MM-DD") : null;
        dataSor.service_category_id = state.sorItem.service_category.id || null;
        dataSor.equipment_group_id = state.sorItem.equipment_structure_type ? state.sorItem.equipment_structure_type.id : null;
        dataSor.property_id = state.sorItem.location_info ? state.sorItem.location_info.id : null;
        dataSor.number_of_required_signature = state.sorItem.number_of_required_signature ? Number(state.sorItem.number_of_required_signature) : null;
        dataSor.checklist_mandatory_complete = state.sorItem.checklist_mandatory_complete ? state.sorItem.checklist_mandatory_complete : false;
        dataSor.is_allow_time_manual = state.sorItem.is_allow_time_manual ? state.sorItem.is_allow_time_manual : false;
        dataSor.is_allow_job_end = state.sorItem.is_allow_job_end ? state.sorItem.is_allow_job_end : false;
        dataSor.is_allow_editing_of_follow_up_after_job_completion = state.sorItem.is_allow_editing_of_follow_up_after_job_completion ? state.sorItem.is_allow_editing_of_follow_up_after_job_completion : false;
        dataSor.is_allow_user_to_enter_timestamp_for_issue_action_taken = state.sorItem.is_allow_user_to_enter_timestamp_for_issue_action_taken ? state.sorItem.is_allow_user_to_enter_timestamp_for_issue_action_taken : false;
        dataSor.status = "active";
        dataSor.default_supplier_id = state.sorItem.default_supplier && state.sorItem.default_supplier.id ? state.sorItem.default_supplier.id : null;

        //Create new SOR item
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "popup",val: true} );
            if(dataSor.id){
                global.axios.put(`api/sor/${dataSor.id}`, dataSor)
                    .then(response => {
                        commit( 'setLoadings', {key: "popup",val: false} );
                        resolve( response );
                    })
                    .catch(error => {
                        commit( 'setLoadings', {key: "popup",val: false} );
                        reject(error)
                    });
            }else{
                global.axios.post(`api/sor`, dataSor)
                    .then(response => {
                        commit( 'setLoadings', {key: "popup",val: false} );
                        dataSor.id = response.data.data.id;
                        commit( 'setItem', dataSor);
                        resolve( response.data.data );
                    })
                    .catch(error => {
                            commit( 'setLoadings', {key: "popup",val: false} );
                            reject(error)
                        }
                    );
            }

        });
    },
    async createItem({dispatch,commit,state},dataSor){
        //Create new SOR item
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "popup",val: true} );
            if(dataSor.id){
                global.axios.put(`api/sor/${dataSor.id}`, dataSor)
                    .then(response => {
                        resolve( response );
                    })
                    .catch(error => {
                        reject(error)
                    });
            }else{
                global.axios.post(`api/sor`, dataSor)
                    .then(response => {
                        resolve( response.data.data );
                    })
                    .catch(error => {
                            reject(error)
                        }
                    );
            }

        });
    },
    async saveVendorLinkingSOR({commit}, params){
        params.original_unit_price = parseFloat(params.original_unit_price);
        //Create new SOR item
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "popup",val: true} );
            global.axios.put(`api/s-contracts/sor/${params.sor_item_id}/vendor-linking-sor/${params.id}`, params)
                .then(response => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoadings', {key: "popup",val: false} );
                    reject( error )
                });

        });
    },
    async createVendorLinkingSOR({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "popup",val: true} );
            global.axios.post(`api/s-contracts/${params.contract_id}/vendor-linking-sor`, params)
                .then(response => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoadings', {key: "popup",val: false} );
                    reject( error )
                });

        });
    },

    async adjustmentItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/sor/price-adjustment`, params)
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                });

        });
    },
    checkValidate({dispatch,commit,state}){
        return new Promise (( resolve, reject ) => {
            let dataSor = state.sorItem;
            if(!dataSor.sor_group_id
                || !dataSor.sor_code
                || !dataSor.service_category
                || (dataSor.unit_price === null || dataSor.unit_price === undefined || dataSor.unit_price === '')
            ){
                commit("setValidate",true);
                reject( "Please enter in all the fields" );
            }
            resolve( true );
        });
    },
    getItem({commit},params){
        let id = params;
        commit( 'setLoadings', {key: "popup",val: true} );
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/sor/${id}`,{
            })
                .then(response => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    commit( 'setItem', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    //Group
    async getGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            let groupRootId = params;
            commit( 'setLoadings', {key: "group",val: true} );
            global.axios(`api/sor/group/${groupRootId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setLoadings', {key: "group",val: false} );
                    commit( 'setGroup', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    //Get Group v2
    async getTreeSORGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/group`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createGroup({commit}, params){
        commit( 'setLoadings', {key: "popup",val: true} );
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/group`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    reject(error)
                });
        });
    },
    async deleteGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key: "group",val: true} );
            global.axios.delete(`api/sor/group/${params.id}`, {
                data:{
                    sor_group_id: params.sor_group_id,
                    deleteItemsInGroup: params.deleteItemsInGroup,
                }
            })
                .then(response => {
                    //commit( 'setGroup', response.data.data );
                    commit( 'setLoadings', {key: "group",val: false} );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async updateGroup({commit}, params){
        commit( 'setLoadings', {key: "popup",val: true} );
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/group/${params.id}`, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setLoadings', {key: "popup",val: false} );
                    resolve( response.data.data  );
                })
                .catch(error => reject( error ));
        });
    },
    //Service category
    getServices({commit}, params){
        return new Promise (( resolve, reject ) => {
            let root_id = params;
            commit( 'setLoadings', {key: "service",val: true} );
            global.axios.get(`api/service-category/tree`, {
                params: {
                    root_id: root_id,
                }
            })
                .then(response => {
                    commit( 'setServices', response.data.data );
                    commit( 'setLoadings', {key: "service",val: false} );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    getService({commit}, params){
        return new Promise (( resolve, reject ) => {
            let contract_id = params.contract_id;
            let service_id = params.service_id;
            global.axios(`api/contracts/${contract_id}/tree-service-categories/${service_id}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if (!params.service_id) {
                        commit('setServiceCategories', response.data.data);
                    }
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    importSOR({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImportSOR);
            commit( 'setLoadings', {key: "import",val: true} );
            global.axios.post(`api/sor/import/${params.id}`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoadings', {key: "import",val: false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoadings', {key: "import",val: false} );
                    reject( error )
                } );
        });
    },
    importMaintenance({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImportSOR);
            formData.append('contract_term_id',params.id);
            commit( 'setLoadings', {key: "import",val: true} );
            global.axios.post(`api/maintenance/import/`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    importMaintenanceStandard({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            global.axios.post(`api/maintenance/import-standard/`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },

    //Clone from master
    cloneMaster({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/sor/clone`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                        reject(error)
                    }
                );
        });
    },
    async searchSorCode({commit}, params){
        let page = params[0];
        let limit = params[1];
        let group_id = params[2];
        let filter = params[3];
        let client_contract_id = params[4] ? params[4] : null;
        let supplier_id = params[5] ? params[5] : null;
        let order_id = params[6] ? params[6] : null;
        let sortMultipleColumn = params[7] ? params[7] : null;
        let cancelToken = params[8] ? params[8] : null;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/sor`, {params:{
                    page:page,
                    group_id:group_id,
                    limit:limit,
                    filter:filter,
                    client_contract_id:client_contract_id,
                    supplier_id:supplier_id,
                    order_id: order_id,
                    sortMultipleColumn: sortMultipleColumn
                },
                cancelToken: cancelToken,
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async UpdateSorItemSupplier({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/s-contracts/${params.id}`,{
                method: "PUT",
                data : params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });

    },

    //Versioning
    importSORVerersioning({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.file);
            formData.append('contract_id',params.contract_id);
            formData.append('supplier_id',params.supplier_id);
            commit( 'setLoadings', {key: "import",val: true} );
            global.axios.post(`api/sor/import/versioning`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoadings', {key: "import",val: false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoadings', {key: "import",val: false} );
                    reject( error )
                } );
        });
    },
    async getVersioningItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/sor/versionings`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    setLoadings(state,data){
        state.Loadings[data.key] = data.val;
    },
    setGroup (state,sorGroup) {
        state.Groups = sorGroup.tree_sor_groups;
    },
    setServices (state,data) {
        if(data && data.tree_service_categories)
            state.Services = data.tree_service_categories;
    },
    setItem (state,sorItem) {
        if(sorItem){
            sorItem._start_date = sorItem.effective_date ? new Date(moment(sorItem.effective_date,"YYYY-MM-DD").toISOString()) : null;
            state.sorItem = sorItem;
            state.sorItem.sor_group = sorItem.sor_group ?{
                id:sorItem.sor_group ? sorItem.sor_group.id : null,
                description_one:sorItem.sor_group ? sorItem.sor_group.description_one : null
            } : null;
            state.sorItem.service_category = sorItem.service_category ? {
                id:sorItem.service_category ? sorItem.service_category.id : -1,
                name:sorItem.service_category ? sorItem.service_category.name : null
            } : null;
            state.sorItem.equipment_structure_type = sorItem.equipment_structure_type ? {
                id:sorItem.equipment_structure_type ? sorItem.equipment_structure_type.id : -1,
                name:sorItem.equipment_structure_type ? sorItem.equipment_structure_type.name : null
            } : null;
            if(!sorItem.location_info) {
                state.sorItem.location_info = sorItem.property_id ? {
                    id: sorItem.property_id ? sorItem.property_id : -1,
                    name: sorItem.property_name ? sorItem.property_name : null
                } : null;
            }
            if(!sorItem.get_sor_recurring_mode) {
                state.sorItem.get_sor_recurring_mode = sorItem.sor_recurring_mode_id ? {
                    id: sorItem.sor_recurring_mode_id ? sorItem.sor_recurring_mode_id : -1,
                    recurring_mode: sorItem.recurring_mode ? sorItem.recurring_mode : null
                } : null;
            }

            state.sorItem.unit_price_tmp = sorItem.unit_price;
            state.sorItem.is_maintenance = sorItem.is_maintenance;
            state.sorItem.number_of_required_signature = state.sorItem.number_of_required_signature ? state.sorItem.number_of_required_signature.toString() : '0';
            state.sorItem.preset_actions = sorItem.preset_actions && sorItem.preset_actions.length ? sorItem.preset_actions : [];
        }else{
            state.sorItem = {
                description_one             :null,
                description_two             :null,
                sor_code                    :null,
                sor_group_id                :null,
                sor_group                   :null,
                service_category            :null,
                unit_price                  :null,
                original_unit_price         :null,
                unit_price_tmp              :null,
                is_maintenance              :null,
                _start_date                 :null,
                unit_of_measurement         :null,
                max_qty                     :null,
                min_qty                     :null,
                contract_term_id            :null,
                service_category_id         :null,
                fault_type                  :null,
                work_type                   :null,
                equipment_structure_type    :null,
                property_id                 :null,
                location_info               :null,
                brand                       :null,
                model                       :null,
                tolerance_period            :null,
                sor_recurring_mode_id       :null,
                checklist_template_id       :null,
                contract_term               :null,
                standard_reference          :null,
                remarks                     :null,
                abbreviation                :null,
                is_allow_time_manual        :false,
                is_allow_job_end            :false,
                is_allow_editing_of_follow_up_after_job_completion: false,
                number_of_required_signature:'0',
                checklist_mandatory_complete:false,
                preset_actions: [],
                editing_of_issue: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
                editing_of_checklist: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
                editing_of_job_data: ["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"],
                is_allow_user_to_enter_timestamp_for_issue_action_taken: false,
                auto_renew_job: null,
                brand: null,
                default_supplier: null,
                default_supplier_id: null,
                pre_condition_checklist_template_id: null,
                is_pre_condition_checklist_mandatory_complete: false,
                is_allow_uploading_photos_gallery_mobile: false,
                is_allow_auto_fill_checklist_mobile: true,
                geo_fencing_applicable_states: null,
                is_allow_auto_creating_cwo_from_jobs_issues: false,
                is_allow_fm_officer_to_do_expired_jobs: false,
            }
        }
    },
    setValidate(state,val){
        state.Validate = val;
    },
    setServiceCategories(state, payload) {
        state.serviceCategories = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
